// Web3 社群 / 交流工具入口。
// DeBox 等类微信的加密交易交流工具——从「交易所注册」页迁出，作为社群入口在首页/导航/学院/市场侧边栏多处展示。
export const communityGroups = [
  {
    id: 'debox',
    name: 'DeBox',
    badge: 'Web3 社交',
    accent: '#21c161',
    logo: '/images/exchanges/debox-logo.svg',
    tagline: '类微信的加密交易交流工具',
    desc: '加入 GHOST 交易社群，和研究型交易者一起复盘行情、分享信号、交流策略。',
    joinLabel: '加入社群',
    joinUrl: 'https://x.debox.pro/uz7lyef8',
  },
];

export const primaryCommunity = communityGroups[0];
export const joinCommunityUrl = primaryCommunity.joinUrl;
